import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { servicesSchema } from '../../../../dashboard/components/utility/schema-defs';
import { getServices } from '../../actions/actionType/services/GetServicesTypes';
import {
  cleargetServices,
  getServicesFailure,
  getServicesStart,
  getServicesSuccessful
} from '../../actions/sagaActions/services/GetServicesSagaActions';
import {
  GetServicesFailurePayload,
  GetServicesRequest
} from '../../actions/types/services/GetServiceTypes';

/**
 * Call Get services by API
 * @returns api response
 */
interface Service {
  serviceName: string;
}

export interface ServiceRequest {
  serviceType: string;
  services: Service[];
  status?: string[];
}

export async function callGetServicesApi(data: ServiceRequest) {
  return apiWrapper.post(`${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/services/search`, data);
}

export function* getServicesApi({
  requestObject
}: GetServicesRequest) {
  yield put(cleargetServices());
  yield put(getServicesStart());
  try {
    const { responseBody: data, isError, error } = yield call(callGetServicesApi, requestObject);
    if (isError) {
      throw error;
    }
    const apiResponse = servicesSchema.validate(data, {
      abortEarly: true
    });
    if (apiResponse.error) {
      throw new Error('No Response');
    } else if (data) {
      yield put(getServicesSuccessful(data));
    }
  } catch (error: any) {
    const obj: GetServicesFailurePayload = {
      error: 'Unable to load Services'
    };
    yield put(getServicesFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* GetServicesSaga() {
  yield takeLatest(
    getServices.FETCH_SERVICES_REQUEST,
    getServicesApi
  );
}

export const getServicesSaga = [fork(GetServicesSaga)];
